import { render } from "./selectImmobiliForecastModal.vue?vue&type=template&id=4df20a03&ts=true"
import script from "./selectImmobiliForecastModal.vue?vue&type=script&lang=ts"
export * from "./selectImmobiliForecastModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__